document.querySelectorAll('[data-special-popup]').forEach(function(root) {
  var dialog = root.querySelector('dialog');
  if (!dialog || !dialog.showModal) return;
  var key = 'linnovateur-special:' + root.dataset.key;
  var expiry = root.dataset.expiry;
  var expiration = expiry ? Date.parse(expiry) : Infinity;
  var expired = function() { return Number.isNaN(expiration) || Date.now() >= expiration; };
  var seen = false;
  try { seen = sessionStorage.getItem(key) === 'seen'; } catch (_) {}
  function remember() { seen = true; try { sessionStorage.setItem(key, 'seen'); } catch (_) {} }
  function show(preview) {
    if (dialog.open) return;
    if (!preview && (seen || expired() || root.dataset.enabled !== 'true' || root.dataset.hasLink !== 'true')) return;
    dialog.showModal();
    if (!preview) remember();
  }
  root.querySelectorAll('[data-special-close]').forEach(function(button) { button.addEventListener('click', function() { dialog.close(); }); });
  dialog.querySelectorAll('a').forEach(function(link) { link.addEventListener('click', function(event) {
    var destination = new URL(link.href, window.location.href);
    if (destination.origin === location.origin && destination.pathname === location.pathname && destination.hash) {
      var section = document.getElementById(destination.hash.slice(1));
      if (section) { event.preventDefault(); dialog.close(); section.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); }
    }
  }); });
  dialog.addEventListener('click', function(event) { if(event.target === dialog) { var rect = dialog.getBoundingClientRect(); if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  var preview = root.querySelector('[data-special-preview]');
  if (preview) preview.addEventListener('click', function() { show(true); });
  if (root.dataset.enabled === 'true' && root.dataset.hasLink === 'true' && !seen && !expired()) {
    var timer = setInterval(function() {
      if (expired()) { clearInterval(timer); return; }
      if (document.hidden || document.querySelector('.cart-drawer.is-open, .search-flyout.is-open, .design-mobile-menu[open], dialog[open]')) return;
      show(false); clearInterval(timer);
    }, Math.max(5, Number(root.dataset.delay) || 12) * 1000);
  }
});
